import { Body1, Box, Color, FontFamily } from '@gousto-internal/citrus-react'
import React from 'react'

/**
 * This component renders the promo banner copy exactly as in the
 *  immersive hero experiment and it's usage depends on the Immersive Hero
 *  being the Hero component used in the homepage redesign experiment.
 */
export function PromoBannerText({ children }: { children: string }) {
  return (
    <Box maxWidth={'100%'}>
      <Body1 color={Color.White} size={[2, 3]} fontFamily={FontFamily.Bold}>
        {children}
      </Body1>
    </Box>
  )
}
